import ReactDOM from 'react-dom/client';
import { StrictMode } from 'react';
import { retrieveLaunchParams } from '@tma.js/sdk-react';
import config from '@/config';

if (config.sentry.loadOnStartup) {
  void import('@/monitoring/sentry').then(({ initSentry }) => initSentry());
}
import { Root } from '@/components/Root.tsx';
import EnvUnsupported from '@/components/EnvUnsupported.tsx';
import { init } from '@/init.ts';
import '@/i18n';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './index.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Mock the environment in case, we are outside Telegram.
import './mockEnv.ts';

const root = ReactDOM.createRoot(document.getElementById('root')!);

try {
  const launchParams = retrieveLaunchParams();
  const { tgWebAppPlatform: platform } = launchParams;

  init({
    debug: import.meta.env.VITE_DEBUG_MODE === 'true',
    eruda: import.meta.env.VITE_DEBUG_MODE === 'true',
    mockForMacOS: platform === 'macos',
  });

  const app = (
    <StrictMode>
      <Root />
    </StrictMode>
  );

  root.render(
    <GoogleReCaptchaProvider reCaptchaKey={config.reCaptchaKey}>{app}</GoogleReCaptchaProvider>
  );
} catch {
  root.render(<EnvUnsupported />);
}
